export const NAMESPACE = 'KanBo/license/'
export const SET = NAMESPACE + 'SET'

const initialState = {
  type: '',
  expireCurrent: 0,
  expireMax: 0,
  features: [],
  name: '',
  writersCurrent: 0,
  writersMax: 0,
  readersCurrent: 0,
  readersMax: 0
}

export default function reducer (state = initialState, action = {}) {
  switch (action.type) {
    case SET:
      return {
        ...state,
        ...action.payload
      }
    default: return state
  }
}

export function set (payload) {
  return {
    type: SET,
    payload
  }
}
